import { create } from 'zustand'

interface SearchResultsState {
  prefetchedQuery: string
  prefetchedQueryID: string | null
  prefetchedProductIds: string[]
}

interface SearchResultsStateActions {
  setPrefetchedResultsData: (data: {
    query: string
    queryID: string | null
    productIds: string[]
  }) => void
  clearPrefetchedResultsData: () => void
}

const useSearchResultsStore = create<
  SearchResultsState & SearchResultsStateActions
>(set => ({
  prefetchedQuery: '',
  prefetchedQueryID: null,
  prefetchedProductIds: [],
  setPrefetchedResultsData: data =>
    set({
      prefetchedQuery: data.query,
      prefetchedQueryID: data.queryID,
      prefetchedProductIds: data.productIds
    }),
  clearPrefetchedResultsData: () =>
    set({
      prefetchedQuery: '',
      prefetchedQueryID: null,
      prefetchedProductIds: []
    })
}))

export default useSearchResultsStore
